import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import RegistryPanel from "@/components/RegistryPanel";
import ResourceLeveling from "@/components/ResourceLeveling";

export default function ResourcesView({ projectId, tasks, onOpenTask, onChanged, emptyTasks }) {
  return (
    <Tabs defaultValue="registry" data-testid="resources-view">
      <TabsList>
        <TabsTrigger value="registry" data-testid="subtab-registry">Team & registry</TabsTrigger>
        <TabsTrigger value="allocation" data-testid="subtab-allocation">Allocation map</TabsTrigger>
      </TabsList>
      <TabsContent value="registry" className="mt-4">
        <RegistryPanel projectId={projectId} onAdded={onChanged} />
      </TabsContent>
      <TabsContent value="allocation" className="mt-4">
        {tasks.length === 0 ? emptyTasks : <ResourceLeveling projectId={projectId} tasks={tasks} onOpenTask={onOpenTask} onChanged={onChanged} />}
      </TabsContent>
    </Tabs>
  );
}
